import { css } from "styled-components";
import token from "styled-token";
import { SliderThumbMixin, SliderTrackMixin } from "./SliderMixin"; // Styling based on:
// http://danielstern.ca/range.css/#/

var thumbsCSS = function thumbsCSS(props) {
  return token("shadows.focus", function (focusBoxShadow) {
    return css(["&::-webkit-slider-thumb{", " -webkit-appearance:none;margin-top:-11px;}&::-moz-range-thumb{", "}&::-ms-thumb{", " height:6px;margin-top:0;}&:focus::-webkit-slider-thumb{box-shadow:", ";}&:focus::-moz-range-thumb{box-shadow:", ";}"], SliderThumbMixin(props), SliderThumbMixin(props), SliderThumbMixin(props), focusBoxShadow, focusBoxShadow);
  })(props);
};

var trackCSS = function trackCSS(props) {
  return css(["", " width:100%;"], SliderTrackMixin(props));
};

var tracksCSS = function tracksCSS(props) {
  return token({
    backgroundColor: "Slider.trackBackgroundColor",
    borderRadius: "radii.ellipse"
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
        borderRadius = _ref.borderRadius;
    return css(["&::-webkit-slider-runnable-track{", "}&::-moz-range-track{", "}&::-moz-focus-outer{border:0;}&::-ms-track{", " background:transparent;border-color:transparent;color:transparent;}&::-ms-fill-lower{background:", ";border-radius:", ";}&::-ms-fill-upper{background:", ";border-radius:", ";}"], trackCSS(props), trackCSS(props), trackCSS(props), backgroundColor, borderRadius, backgroundColor, borderRadius);
  })(props);
};
/** @class RangeMixin */

/** @method */


export var RangeMixin = function RangeMixin(props) {
  return css(["-webkit-appearance:none;height:auto;width:100%;margin:11px 0;border:none;box-shadow:none;&:focus{box-shadow:none;outline:none;}", " ", ""], thumbsCSS(props), tracksCSS(props));
};